import React, { useState, useEffect } from "react";
import { CircularProgress } from "@material-ui/core";

// Fallback calmo para transição de rota (Suspense de lazy chunks).
// Diferente do BackdropLoading (overlay fixed + véu branco 90% + blur),
// aqui renderiza NADA nos primeiros 250ms — carregamentos rápidos (o caso
// comum, chunk em cache/rede boa) não piscam nenhum loader. Só aparece um
// spinner discreto e in-flow se a transição demorar de verdade.
const RouteFallback = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), 250);
    return () => clearTimeout(timer);
  }, []);

  if (!show) return null;

  return (
    <div
      role="status"
      aria-label="Carregando"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        width: "100%",
      }}
    >
      <CircularProgress size={32} />
    </div>
  );
};

export default RouteFallback;
